<template>
    <template v-if="ModulesDailyLotto.cartDaily.length > 0">
        <h3 class="betslip__body-title">
            {{ getTranslatedText('Lotto daily') }}
        </h3>
        <div class="betslip__body-list">
            <div class="betslip__body-list__item" v-for="(item, index) in ModulesDailyLotto.cartDaily" :key="index">
                <div class="betslip__body-list__item-line border">
                    <span class="betslip__title">
                        {{ getTranslatedText(item.draw_name) }}
                    </span>
                    <span class="betslip__price">{{ renderPrice(item.price * item.combinations * (item?.multiplier || 1)) }}</span>
                </div>
                <div class="betslip__body-list__item-line">
                    <div :class="['betslip__type', item.type?.toLowerCase()]">
                        {{ getTranslatedText(item.type) }}
                    </div>
                    <span class="betslip__text-value"> {{ renderDate(item.date) }}</span>
                </div>
                <div class="betslip__body-list__item-line">
                    <div class="betslip__title-column">
                        <span class="betslip__title-column-text">
                            {{ getTranslatedText(item.marketName) }} {{ renderTextTickets(item.selection) }}
                        </span>
                        <span v-if="item.market_option" class="betslip__market-option">
                            {{ getTranslatedText(item.market_option === 'machine_number' ? 'Machine Number' : 'Normal') }}
                        </span>
                    </div>
                    <div class="betslip__potential-winnings">
                        <span class="betslip__text-value">{{ getTranslatedText('Potential Winnings') }}:</span>
                        <p class="betslip__price">
                            {{ renderPrice(item.potentialWinnings) }}
                        </p>
                    </div>
                </div>
                <div class="betslip__body-list__item-line">
                    <span class="betslip__title-column">
                        {{ getTranslatedText('Lines') }}: {{ item.combinations }}
                    </span>
                </div>
                <ButtonCommon
                    :isNoHover="true"
                    :isDisable="isLoadingButton"
                    type="outline"
                    value="remove"
                    @on-click-button-common="onRemoveItem(item)"
                />
            </div>
        </div>
        <div class="betslip__footer">
            <div class="betslip__footer-total">
                <span class="betslip__footer-total-title">
                    {{ getTranslatedText('total') }} ({{ ModulesDailyLotto.cartDaily?.length }})
                </span>
                <span class="betslip__footer-total-price">
                    {{ renderTotal() }}
                </span>
            </div>
            <div class="betslip__footer-box-btn">
                <ButtonCommon
                    :isNoHover="true"
                    :isDisable="isLoadingButton"
                    type="outline"
                    value="Effacer"
                    @on-click-button-common="onShowConfirmClear()"
                />
                <ButtonCommon
                    :isNoHover="true"
                    :isLoading="isLoadingButton"
                    value="Valide"
                    @on-click-button-common="onCheckSettleRaffle()"
                />
            </div>
        </div>
    </template>
    <div v-else class="betslip__empty">
        <p>{{ getTranslatedText('cart empty') }}</p>
        <ButtonCommon
            :isNoHover="true"
            type="outline"
            value="Add Bets"
            @on-click-button-common="$emit('continue-paying')"
        />
    </div>
    <Dialog
        :show="dialog.isOpen"
        :buttonLeftName="`close`"
        :buttonRightName="`ok`"
        title="confirm"
        content="Are you sure you want to delete"
        @close="dialog.isOpen = false"
        @accept="onClearCart()"
    />
    <Dialog class="popup-raffle-promotion" :show="dialog.isOpenRaffle" :isShowButton="false">
        <template #dialogContent>
            <div class="betslip__popup-title">
                <span class="betslip__popup-title-text">
                    {{ getTranslatedText('Register for Raffle') }}
                </span>
            </div>
            <div class="betslip__popup">
                <template v-for="item in formItem" :key="item">
                    <InputCommon
                        :value="phoneNumber"
                        :inputItem="item"
                        :isInputDefault="true"
                        @on-change-input-common="onChangePhoneNumber"
                    />
                </template>
                <div class="betslip__popup-button">
                    <ButtonCommon
                        :isNoHover="true"
                        type="outline"
                        value="close"
                        @on-click-button-common="dialog.isOpenRaffle = false"
                    />
                    <ButtonCommon
                        :isNoHover="true"
                        value="continue"
                        @on-click-button-common="onValidatePhoneNumber()"
                    />
                </div>
            </div>
        </template>
    </Dialog>
</template>
<script>
import { mapState } from 'vuex';
import { formatDateUTC, formatPrice, isStrEmpty } from '@/utils/utils';

import LottoService from '@/services/loto/loto.service';

import languageMixins from '@/mixins/language-mixins';
import functionMixins from '@/mixins/function-utils';
import printMixins from '@/mixins/print-mixins';

import ButtonCommon from '@/components/common/button/button.vue';
import Dialog from '@/components/common/dialog/dialog.vue';
import InputCommon from '@/components/common/input/input.vue';

import EventBus from '@/utils/EventBus';

export default {
    mixins: [languageMixins, functionMixins, printMixins],
    components: { ButtonCommon, Dialog, InputCommon },
    data() {
        return {
            isLoadingButton: false,
            phoneNumber: '',
            dialog: {
                isOpen: false,
                isOpenRaffle: false,
            },
            formItem: [
                {
                    label: 'phone number (optional)',
                    name: 'phoneNumber',
                    type: 'text',
                    required: true,
                    isNote: false,
                    noteValue: 'Invalid phone number',
                    placeholder: 'Phone Number',
                    isNumericPassword: true,
                },
            ],
        };
    },
    computed: {
        ...mapState(['ModulesDailyLotto']),
    },
    methods: {
        showNotification(message, type) {
            const param = { text: message, type };
            EventBus.emit('show-notications', param);
        },

        onCheckSettleRaffle() {
            const isCheckRafflePromotion = this.ModulesDailyLotto.cartDaily.some((item) => item?.raffle_promotion_id);

            if (isCheckRafflePromotion) {
                this.dialog.isOpenRaffle = true;
                return true;
            }

            this.onTransactCart();
        },

        onValidatePhoneNumber() {
            const phoneRegex = /^[0-9]{10,11}$/;
            if (isStrEmpty(this.phoneNumber) || phoneRegex.test(this.phoneNumber)) {
                this.onTransactCart();
                this.formItem[0].isNote = false;
                this.dialog.isOpenRaffle = false;
                return;
            }

            this.formItem[0].isNote = true;
        },

        async onTransactCart() {
            this.isLoadingButton = true;
            try {
                const respCheckDevice = await LottoService.deviceBindingcheck();
                if (respCheckDevice.code === 200 || respCheckDevice.status === 'success') {
                    const respToken = await LottoService.getTokenDaily();
                    if (respToken.code === 200 || respToken.status === 'success') {
                        let bets = {
                            entries: [],
                        };

                        this.ModulesDailyLotto.cartDaily.forEach((x) => {
                            const wager = x.price
                            bets.entries.push({
                                game: x.slug,
                                market: x.marketSlug,
                                wager,
                                draws: 1,
                                selection: [x.selection],
                                market_option: x.market_option || 'normal', // Add market_option (normal or machine_number)
                            });
                        });
                        bets = [bets];
                        const resp = await LottoService.transactDaily(bets, respToken.data.token, this.phoneNumber);
                        if (resp.status === 'success' && resp.code === 200) {
                            this.printLottoDaily(resp.data);
                            this.showReprintDialog(resp.data)
                        } else {
                            this.showNotification(resp.message, 'warning');
                        }
                    } else {
                        this.showNotification(respToken.message, 'error');
                    }
                } else {
                    this.showNotification(respCheckDevice.message, 'error');
                }
            } catch (error) {
                this.showNotification(
                    error === 'ECONNABORTED'
                        ? this.getTranslatedText('Request timeout. Please check your network connection.')
                        : error,
                    'error',
                );
            } finally {
                this.isLoadingButton = false;
            }
        },

        showReprintDialog(paramPrint) {
            this.onClearCart();
            let betslipId = paramPrint?.transaction?.externalId ?? paramPrint?.transaction?.external_id ?? ''
            EventBus.emit('on-show-reprint', {
                ticketType: 'L',
                reference: paramPrint?.transaction?.reference,
                betslipId: betslipId.startsWith('L-') ? betslipId : 'L-' + betslipId,
                paramPrint: paramPrint,
                forLotto: true,
            })
        },

        //Action remove cart
        onShowConfirmClear() {
            this.dialog.isOpen = true;
        },

        onClearCart() {
            const payload = {
                cart: [],
                total: 0,
            };
            this.$store.dispatch('ModulesDailyLotto/actionRemoveCart', payload);
            this.dialog.isOpen = false;
        },

        onRemoveItem(item) {
            const index = this.ModulesDailyLotto.cartDaily.findIndex((x) => x.id === item.id);
            if (index !== -1) {
                const payload = {
                    cart: this.ModulesDailyLotto.cartDaily,
                };
                payload.cart.splice(index, 1);
                payload['total'] = payload['cart'].length;
                this.$store.dispatch('ModulesDailyLotto/actionRemoveCart', payload);
            }
        },

        // action change phone number
        onChangePhoneNumber(param) {
            this.formItem[0].isNote = false;
            this.phoneNumber = param.event.target.value;
        },

        // common
        renderTextTickets(arr) {
            let valueBallRender = '';
            arr.forEach((x, index) => {
                valueBallRender = `${valueBallRender}${index !== 0 ? ', ' : ''}${x}`;
            });
            return `(${valueBallRender})`;
        },

        renderIndexTable(index) {
            let no = index + 1;
            no = no < 10 ? `0${no}` : no;
            return no;
        },

        renderDate(date) {
            const dateFormat = formatDateUTC(date, 2);
            const { hour, minutes, day, year, month } = dateFormat;

            const time = ` ${hour}:${minutes}`;

            const valueDate = `${day}/${month}/${year} ${time}`;

            return valueDate;
        },

        renderTotal() {
            const data = this.ModulesDailyLotto.cartDaily;
            const totalPrice = data.reduce((acc, item) => acc + parseFloat(item.price) * item.combinations * (item?.multiplier || 1), 0);
            return this.renderPrice(totalPrice);
        },

        renderPrice(price, decimal = 2) {
            const priceFormat = `${this.$store.state.config.setup.currency} ${formatPrice(price, decimal)}`
            return priceFormat;
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/betslip/betslip-lotto-card.scss';
</style>
